<template>
  <div class="form-header">
    <img class="logo" src="@/assets/small-logo.png" alt="logo" />
    <div class="title">
      <div>南京市市政设计研究院有限责任公司</div>
      <div>{{ title }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
  },
};
</script>

<style lang="less" scoped>
.form-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;

  .logo {
    height: 120px;
    margin-right: 30px;
  }

  .title {
    font-size: 24px;
    font-weight: 400;
    line-height: 38px;
    color: rgba(0, 0, 0, 0.85);
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>